import axios from 'axios';

export const isAuthenticated = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}auth/check`, { withCredentials: true });
    return {isAuth: response.data.isAuthenticated, role: response.data.user.role};
  } catch (error) {
    return false;
  }
};